import { SxProps, Theme } from '@mui/material'

export const itemImageSx: SxProps<Theme> = {
  width: '100%',
}

export const carouselItemSx = ({
  pointerCursor,
}: {
  pointerCursor: boolean
}): SxProps<Theme> => {
  return {
    boxSizing: 'border-box',
    minWidth: {
      xs: '12rem',
      md: '16rem',
      lg: '19.6rem',
    },
    width: {
      xs: '12rem',
      md: '16rem',
      lg: '19.6rem',
    },
    maxWidth: {
      xs: '12rem',
      md: '16rem',
      lg: '19.6rem',
    },
    minHeight: {
      xs: '5.3rem',
      md: '7.2rem',
      lg: '8.8rem',
    },
    overflow: 'hidden',
    borderRadius: '0.8rem',
    border: (theme) => `0.1rem solid ${theme.palette.divider}`,
    cursor: pointerCursor ? 'pointer' : 'default',
    padding: '0 !important',
    background: (theme) => theme.palette.background.paper,
    '&:hover': {
      background: (theme) => theme.palette.background.paper,
    },
  }
}
